import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import isExternalUrl from 'commons/isExternalUrl';
import normalizeInternalLink from 'commons/normalizeInternalLink';
const CtaWrapper = React.forwardRef((t0, ref) => {
  const $ = _c(18);
  let otherProps;
  let t1;
  let to;
  if ($[0] !== t0) {
    ({
      as: t1,
      to,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = to;
  } else {
    otherProps = $[1];
    t1 = $[2];
    to = $[3];
  }
  const CustomElement = t1 === undefined ? "button" : t1;
  if (!to) {
    let t2;
    if ($[4] !== CustomElement || $[5] !== otherProps || $[6] !== ref) {
      t2 = <CustomElement ref={ref} {...otherProps} />;
      $[4] = CustomElement;
      $[5] = otherProps;
      $[6] = ref;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  if (!isExternalUrl(to)) {
    let t2;
    if ($[8] !== to) {
      t2 = normalizeInternalLink(to);
      $[8] = to;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== otherProps || $[11] !== ref || $[12] !== t2) {
      t3 = <Link to={t2} ref={ref} {...otherProps} />;
      $[10] = otherProps;
      $[11] = ref;
      $[12] = t2;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    return t3;
  }
  let t2;
  if ($[14] !== otherProps || $[15] !== ref || $[16] !== to) {
    t2 = <a href={to} rel="noopener noreferrer" target="_blank" ref={ref} {...otherProps} />;
    $[14] = otherProps;
    $[15] = ref;
    $[16] = to;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
});
CtaWrapper.propTypes = {
  as: PropTypes.string,
  to: PropTypes.string
};
export default CtaWrapper;